<template>
    <div class="Page">
        <Header Act="6"></Header>
        <div class="MaxWid">
            <!-- <div class="MarTop">
                <Banner></Banner>
            </div> -->
            <div class="MarTop">
                <div class="AboutPos">当前位置：信息动态</div>
                <div class="AboutDis">
                    <div class="AboutNav">
                        <div class="AboutNavItem" v-for="item in Data" :class="{Act:i==item.id}" @click="TogglePage(item.id)"><i class="iconfont" :class="{[item.icon]:true}"></i>{{item.name}}</div>
                        <!-- <div class="AboutNavItem" :class="{Act:i==1}" @click="TogglePage(1)"><i class="iconfont icon-jianjie"></i>系统简介</div>
                        <div class="AboutNavItem" :class="{Act:i==2}" @click="TogglePage(2)"><i class="iconfont icon-zuzhi"></i>组织机构</div>
                        <div class="AboutNavItem" :class="{Act:i==3}" @click="TogglePage(3)"><i class="iconfont icon-caidan"></i>管理办法</div>
                        <div class="AboutNavItem" :class="{Act:i==4}" @click="TogglePage(4)"><i class="iconfont icon-xiaoxi"></i>联系我们</div> -->
                    </div>
                    <div class="AboutCont">
                        <div class="QueryContItem" v-for="item in Cont" :key="item.id">
                            <div class="QueryContItemTit" @click="GoDetail(item)">
                                <div class="iconfont icon-shujidaoru"></div>
                                <div>{{item.title}}</div>
                            </div>
                            <div class="QueryContItemCont">
                                <div class="QueryContItemTxt">{{item.synopsis}}</div>
                            </div>
                        </div>
                        <div class="PageDis">
                            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="false"></el-pagination>
                        </div>
                    </div>
                    <!-- <div class="AboutCont" v-if="Cont" v-html="Cont.content"></div> -->
                    <!-- <div class="AboutCont" v-else>暂无数据</div> -->
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    export default {
        components: {Header,Footer,Banner},
        data() {
            return {
                i:1,
                Data: "",
                Cont:"",
                total:0,
                page:1,
                SizePage:10,
            }
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData() {
                this.$get("api/index/informationCategory").then(res => {
                    console.log(res)
                    if(res.data.code == 1){
                        this.Data = res.data.data;
                        this.GetCont(this.Data[0].id)
                    }
                })
            },
            GetCont(id){
                this.Cont = "";
                this.$post("api/index/information",{
                   category_id:id,
                   page:this.page,
                   limit:this.SizePage,
                }).then(res => {
                    if(res.data.code == 1){
                        this.i = id;
                        this.Cont = res.data.data;
                    }
               })
            },
            SizeChange(val) {
                this.SizePage = val;
                this.GetCont();
            },
            PageChange(val) {
                this.page = val;
                this.GetCont();
            },
            TogglePage(i){
                this.i = i;
                this.GetCont(i)
            },
            GoDetail(item) {
                localStorage.setItem("Info",JSON.stringify(item))
                localStorage.setItem("InfoState",6)
                this.$router.push({
                    path: '/InfoDetail',
                });
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }

    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
    }
    .AboutDis{
        display: flex;
        margin-bottom: 30px;
    }
    .AboutNav{
        width: 250px;
        background: #0385EB;
    }
    .AboutNavItem{
        padding: 15px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .AboutNavItem:hover,
    .AboutNavItem.Act{
        background: #fff;
        color: #0385EB;
    }
    .AboutNavItem .iconfont{
        font-size: 22px;
        margin-right: 10px;
    }
    /* .AboutCont{
        max-width: 900px;
        overflow: auto;
        flex: 1;
        margin-left: 20px;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 36px;
    } */
    .AboutCont{
        flex: 1;
        max-width: 900px;
        overflow: auto;
        margin-left: 20px;
    }
    .QueryContItemTit{
        padding: 15px;
        color: #fff;
        font-size: 18px;
        background: #0286eb;
        display: flex;
        cursor: pointer;
    }
    .QueryContItemTit .iconfont{
        /* font-weight: 700; */
        margin-right: 10px;
    }
    .QueryContItemTit div{
        margin-right: 20px;
    }
    .QueryContItemTit div:last-child{
        margin-right: 0;
    }
    .QueryContItemCont{
        padding: 20px 0;
        display: flex;
    }
    .QueryContItemTxt{
        flex: 1;
        line-height: 30px;
        font-size: 16px;
        color: #737373;
    }
    @media only screen and (max-width: 550px){
        .AboutDis{
            display: block;
            margin-bottom: 30px;
        }
        .AboutNav{
            width: 100%;
            display: flex;
            margin-bottom: 20px;
        }
        .AboutNavItem{
            padding: 15px 0;
            font-size: 16px;
            text-align: center;
            flex: 1;
        }
        .AboutNavItem .iconfont{
            display: none;
        }
        .AboutCont{
            margin: 0;
        }
    }
</style>